export default __webpack_public_path__ + "static/media/benefit_2@2x.66da319c.png";